import { render } from "./estimates-list.vue?vue&type=template&id=88880680"
import script from "./estimates-list.vue?vue&type=script&lang=js"
export * from "./estimates-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__